export default __webpack_public_path__ + "img/ratafia.asset.ca257e5f.png";